// Lead Candidate Types

export const CREATE_LEAD_CANDIDATE_REQUEST = "CREATE_LEAD_CANDIDATE_REQUEST";
export const CREATE_LEAD_CANDIDATE_SUCCESS = "CREATE_LEAD_CANDIDATE_SUCCESS";
export const CREATE_LEAD_CANDIDATE_FAILURE = "CREATE_LEAD_CANDIDATE_FAILURE";
export const FETCH_LEAD_CANDIDATE_DETAILS_REQUEST = "FETCH_LEAD_CANDIDATE_DETAILS_REQUEST";
export const FETCH_LEAD_CANDIDATE_DETAILS_SUCCESS = "FETCH_LEAD_CANDIDATE_DETAILS_SUCCESS";
export const FETCH_LEAD_CANDIDATE_DETAILS_FAILURE = "FETCH_LEAD_CANDIDATE_DETAILS_FAILURE";
export const RESET_LEAD_STATE = "RESET_LEAD_STATE";

// Lead Candidate Data Interface
export interface LeadCandidateData {
  name: string;
  email: string;
  phone: string;
  location?: string;
  linked_url?: string;
  linkedin_url?: string;
  job_slug?: string;
  job_id?: number;
  created_at?: string;
  job_title?: string;
  // Absolute S3 URL of the resume the lead uploaded (null until uploaded).
  resume?: string | null;
  status?: string;
  status_display?: string;
}

// Lead State Interface
export interface LeadState {
  loading: boolean;
  success: boolean;
  error: string | null;
  leadData: LeadCandidateData | null;
  leadCandidateDetails: LeadCandidateData | null;
  fetchingDetails: boolean;
  fetchDetailsError: string | null;
  /** Lead id `leadCandidateDetails` belongs to (the payload has no id). */
  detailsLeadId?: number | null;
}

// Action Interfaces
interface CreateLeadCandidateRequestAction {
  type: typeof CREATE_LEAD_CANDIDATE_REQUEST;
}

interface CreateLeadCandidateSuccessAction {
  type: typeof CREATE_LEAD_CANDIDATE_SUCCESS;
  payload: LeadCandidateData;
}

interface CreateLeadCandidateFailureAction {
  type: typeof CREATE_LEAD_CANDIDATE_FAILURE;
  payload: string;
}

interface ResetLeadStateAction {
  type: typeof RESET_LEAD_STATE;
}

interface FetchLeadCandidateDetailsRequestAction {
  type: typeof FETCH_LEAD_CANDIDATE_DETAILS_REQUEST;
  payload?: { leadCandidateId?: number };
}

interface FetchLeadCandidateDetailsSuccessAction {
  type: typeof FETCH_LEAD_CANDIDATE_DETAILS_SUCCESS;
  payload: LeadCandidateData;
}

interface FetchLeadCandidateDetailsFailureAction {
  type: typeof FETCH_LEAD_CANDIDATE_DETAILS_FAILURE;
  payload: string;
}

export type LeadActionTypes =
  | CreateLeadCandidateRequestAction
  | CreateLeadCandidateSuccessAction
  | CreateLeadCandidateFailureAction
  | FetchLeadCandidateDetailsRequestAction
  | FetchLeadCandidateDetailsSuccessAction
  | FetchLeadCandidateDetailsFailureAction
  | ResetLeadStateAction;

